export default {
  form: {
    firstName: 'Fornavn',
    firstNamePlaceholder: 'Angi fornavn',
    lastName: 'Etternavn',
    lastNamePlaceholder: 'Angi etternavn',
    email: 'E-postadresse',
    emailPlaceholder: 'Angi e-postadresse',
    personalNumber: 'Fødselsnummer',
    birthYear: 'Fødselsår',
    biologicalGender: 'Biologisk kjønn',
    geneticGender: 'Genetisk kjønn',
    department: 'Avdeling',
    departmentPlaceholder: 'Angi avdeling, f.eks. HR, IT, Salg',
    market: 'Marked',
    continue: 'Fortsett',
    add: 'Legg til',
    save: 'Lagre',
    saveChanges: 'Lagre endringer',
    changesSaved: 'Endringene ble lagret',
    saveError: 'Noe gikk galt da endringene skulle lagres!',
    cancel: 'Avbryt',
    yes: 'Ja',
    no: 'Nei',
    chooseOption: 'Velg et alternativ',
    choose: 'Velg...',
    language: 'Språk',
    next: 'Neste',
    close: 'Lukk',
    loading: 'Behandler...',
    skip: 'Hopp over',
  },
  market: {
    sweden: 'Sverige',
    norway: 'Norge',
  },
  validation: {
    firstNameRequired: 'Fornavn er påkrevd',
    lastNameRequired: 'Etternavn er påkrevd',
    emailRequired: 'E-postadresse er påkrevd',
    invalidEmail: 'Ugyldig e-postadresse',
    invalidLanguage: 'Vennligst velg et gyldig språk.',
    invalidMarket: 'Vennligst velg et gyldig marked.',
    departmentTooLong: 'Avdeling kan ikke overstige 100 tegn',
  },
  gender: {
    female: 'Kvinne',
    male: 'Mann',
    preferNotToSay: 'Foretrekker å ikke oppgi',
  },
  errors: {
    somethingWentWrong: 'Noe gikk galt! Vennligst prøv igjen eller kontakt support på support@estercare.com',
    tryAgainOrContact: 'Noe gikk galt da vi forsøkte å legge til medarbeideren. Prøv igjen.',
    networkBlocked:
      'Denne funksjonen støttes ikke på nettverket ditt. Vennligst prøv fra et annet nettverk eller kontakt support på support@estercare.com.',
    ssoOrgNotConfigured: 'Arbeidsgiveren din har ikke aktivert EsterCare ennå.',
    ssoLoginFailed:
      'Det var ikke mulig å logge inn via fordelsportalen din. Vennligst prøv igjen eller kontakt support på support@estercare.com',
    ssoUseSsoLogin: 'Denne kontoen logger inn via arbeidsgiveren din. Åpne EsterCare via fordelsportalen din.',
    ssoUsePasswordLogin: 'Denne kontoen logger inn med e-post og passord. Logg inn i portalen på vanlig måte.',
    ssoAccountConflict:
      'Denne kontoen kan ikke brukes til å logge inn via fordelsportalen din. Kontakt support på support@estercare.com',
  },
  navigation: {
    home: 'Hjem',
    overview: 'Oversikt',
    services: 'Tjenester',
    healthCalls: 'Helsesamtaler',
    screening: 'Screening',
    messages: 'Chat',
    statistics: 'Statistikk',
    employees: 'Medarbeidere',
    billing: 'Fakturering',
    support: 'Support',
    training: 'Opplæring',
    knowledgeBank: 'Kunnskapsbank',
    yourHealth: 'Din helseplan',
    myAccount: 'Min konto',
    logout: 'Logg ut',
  },
  file: {
    needsTwoRows: 'Filen må inneholde minst to rader med data.',
    needsThreeColumns: 'Filen må inneholde minst tre kolonner: E-post, fornavn og etternavn.',
    missingValues: 'En eller flere rader mangler verdier i en eller flere kolonner.',
    invalidEmails: 'Ugyldig e-postadresse på en eller flere rader.',
    fileValid: 'Filen er gyldig.',
    managerColumnFormat: 'Kolonnen for lederposisjon må angis som en "true" eller "false" verdi.',
    languageColumnFormat: 'Språkkolonnen må angis som "sv" for svensk eller "en" for engelsk.',
    invalidLanguage: 'Vennligst velg et gyldig språk.',
    dragFileHere: 'Dra filen hit eller klikk i boksen for å importere.',
    dropFileHere: 'Slipp filen her...',
    fileTypeNotSupported: 'Denne filtypen støttes ikke.',
    uploadingFile: 'Behandler filen...',
    uploadFailed: 'Kunne ikke laste opp filen, vennligst prøv igjen.',
    uploadComplete: 'Opplasting fullført!',
  },
  table: {
    name: 'Navn',
    added: 'Lagt til',
    lastLogin: 'Sist innlogget',
  },
  menu: {
    removeUser: 'Fjern bruker',
    removeAdminRights: 'Fjern administratorrettigheter',
    giveAdminRights: 'Gi administratorrettigheter',
    removeManagerRights: 'Fjern personalansvar',
    addManagerRights: 'Legg til personalansvar',
    clearScreening: 'Tøm screeningen min',
    esterInvite: 'Invitert av ',
  },
  alerts: {
    screeningCleared: 'Screeningen din er tømt',
  },
  welcome: {
    greeting: 'Hei {{firstName}}!',
    title: 'Velkommen til EsterCares helseportal',
    subtitle: 'For å komme i gang trenger vi å vite litt mer om deg.',
    zipCode: 'Ditt postnummer',
    errorZipCode: 'Feil format på postnummer',
    errorBirthYear: 'Feil format på fødselsår',
    isManager: 'Jeg har personalansvar',
  },
  notFound: {
    title: 'Siden du leter etter finnes <br /> dessverre ikke',
    imageAlt: 'Tre kvinner som samtaler (illustrasjon)',
    backToHome: 'Gå tilbake til forsiden vår',
  },
  loggedOut: {
    message: 'Du er logget ut. Åpne EsterCare via fordelsportalen din igjen.',
  },
  addEmployee: {
    title: 'Legg til medarbeider',
    addMultipleTitle: 'Legg til flere medarbeidere',
    addMultipleDescription: 'Legg til flere medarbeidere samtidig ved å liste dem i en CSV-fil.',
    templateInstruction: 'Bruk malen vår for å formatere filen på riktig måte.',
    assignManagerRights: 'Gi lederrettigheter?',
    wantToAddMany: 'Ønsker du å legge til mange medarbeidere?',
    wantToAddOne: 'Ønsker du bare å legge til én medarbeider?',
  },
  content: {
    morePodcasts: 'Flere podkastepisoder',
    moreArticles: 'Flere artikler',
    showMore: 'Vis flere',
    toKnowledgeBank: 'Til vår kunnskapsbank',
    article: 'Artikkel',
    podcast: 'Podkast',
    episode: 'Episode',
    webinar: 'Foredrag',
    missingDescription: 'Mangler beskrivelse',
    writtenBy: 'Artikkelen er skrevet av:',
    onlyAvailableInSwedish: 'Kun tilgjengelig på svensk',
  },
  faq: {
    title: 'Vanlige spørsmål',
    noAnswerText: 'Finner du ikke svaret på det du leter etter?',
    visitSupport: 'Besøk brukerstøtten',
  },
  training: {
    confirmCancel: 'Er du sikker på at du vil avbryte?',
    progressNotSaved: 'Hvis du forlater opplæringen nå vil fremgangen din ikke bli lagret.',
    continueTraining: 'Nei, fortsett opplæringen',
    cancelAndLeave: 'Ja, avbryt og forlat',
    duration: 'Varighet',
    minutes: 'min',
    completed: 'Fullført',
    listenSpotify: 'Lytt via Spotify',
  },
  roles: {
    admin: 'Admin',
    employee: 'Ansatt',
    adminTag: 'ADMIN',
    managerTag: 'PERSONALANSVAR',
    invitedTag: 'INVITERT',
  },
  service: {
    active: 'Aktiv',
    readMore: 'Les mer',
  },
  statistics: {
    trainingNotStarted: 'Opplæring ikke påbegynt',
    trainingInProgress: 'Opplæring pågår',
    trainingCompleted: 'Opplæring gjennomført',
  },
  language: {
    swedish: 'Svensk',
    english: 'Engelsk',
    norwegian: 'Norsk',
  },
  other: {
    yourOrganisation: 'din organisasjon',
  },
  dataPolicy: {
    title: 'Slik håndterer vi opplysningene dine',
    titleUpdated: 'Vi har oppdatert personvernerklæringen vår',
    ingress: 'Her er hele personvernerklæringen vår for helseportalen. Du finner den alltid igjen under profilen din.',
    summary:
      'I personvernerklæringen vår beskriver vi hvordan EsterCare behandler personopplysningene dine i helseportalen. Kort sagt: organisasjonen din ser aldri svarene dine, helseplanen din eller meldingene dine.',
    summaryUpdated:
      'Vi har gjort endringer i hvordan vi beskriver behandlingen av personopplysningene dine i helseportalen.',
    readPolicy: 'Les personvernerklæringen',
    compactHint: 'Du finner alltid erklæringen igjen under profilen din.',
    readMore: 'Les mer',
    ingressUpdated:
      'Vi har gjort endringer i hvordan vi beskriver behandlingen av personopplysningene dine. Les gjennom den nye versjonen og bekreft for å fortsette.',
    whatsNew: 'Dette er nytt i versjon {{version}}',
    versionLine: 'Versjon {{version}} · Gjelder fra {{date}}',
    openInNewWindow: 'Åpne i nytt vindu',
    loggedInAs: 'Innlogget som',
    hint: 'Dette er en bekreftelse på at du har tatt del i informasjonen. Samtykke til behandling av helseopplysninger ber vi om separat før screeningen.',
    acknowledge: 'Jeg har tatt del i informasjonen',
    decline: 'Avslå',
    declineTitle: 'Vil du avslå?',
    declineBody:
      'Du må bekrefte at du har tatt del i personvernerklæringen for å bruke helseportalen. Hvis du avslår, blir du logget ut. Kontoen din blir værende, og du kan komme tilbake når som helst.',
    declineConfirm: 'Avslå og logg ut',
    declineBack: 'Tilbake til erklæringen',
    declinedTitle: 'Du er nå logget ut',
    declinedBody:
      'Du må bekrefte at du har tatt del i personvernerklæringen vår for å bruke EsterCares helseportal. Du er nå logget ut og kan komme tilbake når som helst. Ønsker du at kontoen din skal slettes, kontakt organisasjonen din eller support@estercare.com.',
    loginAgain: 'Logg inn igjen',
    menuLink: 'Personvernerklæring',
    loadError: 'Vi kunne ikke laste inn erklæringen. Prøv igjen om litt.',
    submitError: 'Noe gikk galt. Prøv igjen.',
    retry: 'Prøv igjen',
  },
} as const
